export default class StudentDto {
  serialNumber;
  grade;
  classNumber;
  number;
  name;
  email;
  password;
  endDate;
  evaluationStatus;

  constructor(data) {
    this.serialNumber = data.serialNumber;
    this.grade = data.grade;
    this.classNumber = data.classNumber;
    this.number = data.number;
    this.name = data.name;
    this.email = data.email;
    this.password = data.password;
    this.endDate = data.endDate;
    this.evaluationStatus = data.evaluationStatus;
  }
}
